<template>
  <div class="full-height-section">
    <div class="loading-spinner">
      <div class="double-ring">
        <div></div>
        <div></div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped>
@keyframes double-ring {
  0% {
    transform: rotate(0)
  }
  100% {
    transform: rotate(360deg)
  }
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.double-ring div {
  box-sizing: border-box !important
}

.double-ring > div {
  position: absolute;
  width: 144px;
  height: 144px;
  top: 28px;
  left: 28px;
  border-radius: 50%;
  border: 16px solid #000;
  border-color: #30a7fe transparent #30a7fe transparent;
  animation: double-ring 2s linear infinite;
}

.double-ring > div:nth-child(2), .double-ring > div:nth-child(4) {
  width: 108px;
  height: 108px;
  top: 46px;
  left: 46px;
  animation: double-ring 2s linear infinite reverse;
}

.double-ring > div:nth-child(2) {
  border-color: transparent #0769b0 transparent #0769b0
}

.double-ring > div:nth-child(3) {
  border-color: transparent
}

.double-ring > div:nth-child(3) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}

.double-ring > div:nth-child(3) div:before, .double-ring > div:nth-child(3) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  top: -16px;
  left: 48px;
  background: #30a7fe;
  border-radius: 50%;
  box-shadow: 0 128px 0 0 #30a7fe;
}

.double-ring > div:nth-child(3) div:after {
  left: -16px;
  top: 48px;
  box-shadow: 128px 0 0 0 #30a7fe;
}

.double-ring > div:nth-child(4) {
  border-color: transparent;
}

.double-ring > div:nth-child(4) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}

.double-ring > div:nth-child(4) div:before, .double-ring > div:nth-child(4) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  top: -16px;
  left: 30px;
  background: #0769b0;
  border-radius: 50%;
  box-shadow: 0 92px 0 0 #0769b0;
}

.double-ring > div:nth-child(4) div:after {
  left: -16px;
  top: 30px;
  box-shadow: 92px 0 0 0 #0769b0;
}

.loading-spinner {
  /*width: 200px;*/
  height: 200px;
  overflow: hidden;
  background: #F5FBFF;
  width: 100%;
  display: grid;
  place-items: center;
  animation: fadeInAnimation 2s linear;
}

.double-ring {
  width: 200px;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
  /*display: inline;*/

}

.double-ring div {
  box-sizing: content-box;
}

.full-height-section{
  height: calc(100vh - 110px);
}
</style>
